<template>
  <div class="d-flex justify-content-between flex-column">
    <div class="mb-4">
      <p class="text-primary text-small font-weight-bold mb-2">
        {{ trans("courses.word-hunter.step") }} {{ currentStep }}.
      </p>
      <h4 class="text-primary mt-0 mb-3" tabindex="0">
        {{ trans("courses.word-hunter.match_with_emotion") }}
      </h4>

      <h6 class="mb-3" v-html="trans('courses.word-hunter.match_with_emotion_sub')" />
      <div v-for="(keyword, key) in selectedWords" :key="key" class="word-wrapper">
        <div class="border-bottom-light p-3 mb-3 d-flex flex-column">
          <div class="d-flex" tabindex="0">
            <span class="font-weight-bold text-small pt-1 pr-4">{{ key + 1 }}.</span>
            {{ keyword.word }}
          </div>
          <emotions
            :identity="Number(promptId)"
            :emotion-list="activeMoodsList"
            :selected-emotion="keyword.mood_id"
            @emotionChange="dropdownChange($event, key)"
            @buttonClicked="dropdownClicked"
            :button-text="buttonValue(keyword.mood_id)"
          />
        </div>
      </div>
    </div>
    <div>
      <div class="d-flex justify-content-between w-100 mb-3">
        <b-button @click="$emit('prev')" variant="link">{{
          trans("courses.word-hunter.back")
        }}</b-button>
        <loading-button
          :button-text="trans('courses.word-hunter.next')"
          @click="onClickNext"
          :loading="isLoading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Emotions from "../../molecules/Emotions";
import LoadingButton from "../../atoms/LoadingButton";
import { mapGetters } from "vuex";

export default {
  name: "WordMoodMatch",
  components: { Emotions, LoadingButton },
  data() {
    return {
      isLoading: false,
    };
  },
  props: {
    selectedWords: Array,
    currentStep: Number,
    trackingData: Object,
    blockId: Number,
    blockType: String,
    promptId: String,
  },
  methods: {
    onClickNext() {
      this.isLoading = true;
      trackEvent("WordhunterStep3", this.trackingData);
      this.$emit("next");
    },
    dropdownChange(event, index) {
      this.$emit("selectMood", event, index);
      trackEvent("WordhunterMood", this.trackingData);
    },
    dropdownClicked() {
      trackEvent("WordhunterAddMood", this.trackingData);
    },
    buttonValue(moodId) {
      if (moodId) {
        let emotion = this.getMood(moodId);
        return `${emotion.icon} ${emotion.name}`;
      } else return this.trans("mood-reactions.emotion_button_v2");
    },
  },
  computed: {
    ...mapGetters({
      moodsList: "moodsAndReactions/getMoodsList",
      activeMoodsList: "moodsAndReactions/getActiveMoodsList",
      getMood: "moodsAndReactions/getMood",
    }),
    defaultDropdownButton: function () {
      return `${this.moodsList.dropdown.icon} <small>${this.moodsList.dropdown.name}</small>`;
    },
  },
};
</script>

<style scoped lang="scss">
.word-wrapper {
  &:last-child {
    .border-bottom-light {
      border-bottom: none;
    }
  }
}
</style>
